import Body from '@/components/Body'
import {
  AccommodationType,
  EnrollStep,
  STEPS_CONFIG,
} from '@/types/info'
import AgreementService from '@/service/agreementService'
import {
  Button,
  Form,
  Image,
  Input,
  Radio,
  Result,
  Selector,
  Space,
  Steps,
} from 'antd-mobile'

export const MOCK_ORDER_PATH = '/order/gk28fbc8ts'

const ORDER_STEP: Record<EnrollStep, number> = {
  [EnrollStep.inputtting]: 0,
  [EnrollStep.canceled]: 0,
  [EnrollStep.paying]: 1,
  [EnrollStep.selecting]: 2,
  [EnrollStep.allocating]: 3,
  [EnrollStep.end]: 3,
  [EnrollStep.refunded]: 3,
}

const MOCK_ENROLL_STEP = EnrollStep.allocating as EnrollStep
const MOCK_ENCODED_ORDER_ID = 'gk28fbc8ts'
const MOCK_REMAINING_SECONDS = 0
const agreementList = AgreementService.data

const mockOrder = {
  courseName: '笔试冲刺班·省考A类',
  positionCodeName: '2025春招%广东省考%职位代码：A12345',
  regionName: '广州天河校区',
  user_name: '张三',
  user_gender: '男',
  user_phone: '13800001111',
  exam_score: '92.5',
  is_zhuangyuan: true,
  agreement_type: agreementList[0]?.value ?? 'mock-agreement',
  accommodationType: AccommodationType.single,
  classQrCodeUrl:
    'https://dummyimage.com/280x280/1677ff/ffffff.png&text=GK+Class+QR',
}

const showCopyAgreementBtn = [
  EnrollStep.selecting,
  EnrollStep.allocating,
  EnrollStep.end,
].includes(MOCK_ENROLL_STEP)

const btnText = (() => {
  switch (MOCK_ENROLL_STEP) {
    case EnrollStep.paying:
      return '支付费用'
    case EnrollStep.canceled:
      return '已取消'
    default:
      return null
  }
})()

export function MockOrderPage() {
  return (
    <Body>
      <div className="bg-white mb-[7px]">
        <Steps current={ORDER_STEP[MOCK_ENROLL_STEP]}>
          {STEPS_CONFIG.map((step, index) => (
            <Steps.Step key={index} title={step.title} />
          ))}
        </Steps>
      </div>
      <Form style={{ marginBottom: '60px' }} disabled>
        <Form.Item label="课程名称" disabled={false}>
          <Input value={mockOrder.courseName} readOnly />
        </Form.Item>
        <Form.Item
          label={
            <span className="text-[#999] font-[400] text-[15px]">订单号</span>
          }
          layout="horizontal"
          disabled={false}
        >
          <Input value={MOCK_ENCODED_ORDER_ID} readOnly />
        </Form.Item>
        {MOCK_ENROLL_STEP === EnrollStep.paying && (
          <Form.Item
            disabled={false}
            label={
              <span className="text-[#999] font-[400] text-[15px]">
                剩余支付时间
              </span>
            }
          >
            <div style={{ color: '#FF5200', fontWeight: 600 }}>
              {formatSeconds(MOCK_REMAINING_SECONDS)}
            </div>
          </Form.Item>
        )}
        {MOCK_ENROLL_STEP === EnrollStep.canceled && (
          <Form.Item label="订单状态" disabled={false}>
            <div style={{ color: '#FF5200', fontWeight: 600 }}>已取消</div>
          </Form.Item>
        )}
        {MOCK_ENROLL_STEP === EnrollStep.allocating && (
          <Form.Item label="订单状态" disabled={false}>
            <div style={{ color: '#1677ff', fontWeight: 600 }}>等待分配班级</div>
          </Form.Item>
        )}
        {[EnrollStep.allocating, EnrollStep.end].includes(MOCK_ENROLL_STEP) && (
          <>
            <Form.Header>
              群聊二维码
              <span className="text-[#FF5200] text-[14px] mt-[10px] ml-[10px]">
                请立刻扫码进群，否则视为报名失败！
              </span>
            </Form.Header>
            <div style={{ height: '200px', position: 'relative' }}>
              {MOCK_ENROLL_STEP === EnrollStep.end ? (
                <Image
                  width={140}
                  fit="cover"
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                  src={mockOrder.classQrCodeUrl}
                />
              ) : (
                <Result
                  status="waiting"
                  title="等待分配班级"
                  description="请留意服务号和手机短信通知"
                />
              )}
            </div>
          </>
        )}
        <Form.Header>课程信息</Form.Header>
        <Form.Item label="职位代码">
          {mockOrder.positionCodeName.split('%').map((item) => (
            <div key={item}>{item}</div>
          ))}
        </Form.Item>
        <Form.Item label="授课地点" style={{ position: 'relative' }}>
          {mockOrder.regionName}
        </Form.Item>
        <Form.Header>个人信息</Form.Header>
        <Form.Item label="姓名" layout="horizontal">
          <Input value={mockOrder.user_name} />
        </Form.Item>
        <Form.Item label="性别">
          <Radio.Group value={mockOrder.user_gender}>
            <Space style={{ '--gap': '17px' }}>
              <Radio value="男">男</Radio>
              <Radio value="女">女</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="手机号" layout="horizontal">
          <Input value={mockOrder.user_phone} />
        </Form.Item>
        <Form.Item label="笔试分数" layout="horizontal">
          <Input value={mockOrder.exam_score} />
        </Form.Item>
        <Form.Item label="是否守擂">
          <Radio.Group value={mockOrder.is_zhuangyuan.toString()}>
            <Space style={{ '--gap': '17px' }}>
              <Radio value="true">守擂</Radio>
              <Radio value="false">攻擂</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="协议选择">
          <Selector
            options={[
              mockOrder.is_zhuangyuan ? agreementList[0] : agreementList[1],
              agreementList[2],
            ].filter(Boolean)}
            value={[mockOrder.agreement_type]}
            columns={2}
            style={{
              '--gap-horizontal': '27px',
              paddingInline: '31px',
            }}
          />
        </Form.Item>
        <Form.Header>宿舍选择</Form.Header>
        <Form.Item label="宿舍类型" layout="horizontal">
          <Input
            readOnly
            value={
              {
                [AccommodationType.single]: '单人间',
                [AccommodationType.double]: '双人间',
              }[mockOrder.accommodationType] || '签署协议后选择'
            }
          />
        </Form.Item>
        {showCopyAgreementBtn && (
          <Form.Item label="合同预览">
            <div style={{ display: 'flex', gap: 12 }}>
              <Button size="small" color="primary" disabled>
                预览合同
              </Button>
              <Button size="small" color="default" disabled>
                复制下载链接
              </Button>
            </div>
            <p style={{ marginTop: 8, color: '#999' }}>
              若预览加载失败，可点击“复制下载链接”在浏览器中打开
            </p>
          </Form.Item>
        )}
        <div className="p-[12px] bg-white  mt-0 fixed bottom-0 w-[100%]">
          <Button
            block
            type="submit"
            color="primary"
            size="large"
            disabled
            style={{
              display: ![
                EnrollStep.paying,
                EnrollStep.canceled,
              ].includes(MOCK_ENROLL_STEP)
                ? 'none'
                : 'block',
            }}
          >
            {btnText ?? '立即查看订单'}
          </Button>
        </div>
      </Form>
    </Body>
  )
}

function formatSeconds(total: number) {
  const mm = String(Math.floor(total / 60)).padStart(2, '0')
  const ss = String(total % 60).padStart(2, '0')
  return `${mm}:${ss}`
}

